import { parseCornerValue } from '../parser';

export const cornerDecomposeMap = {
  borderRadius: (value: string) => {
    const corner = parseCornerValue(value);

    return Object.fromEntries<string | null>(
      Object.entries(corner) as [string, string | null][],
    );
  },
};
